import * as types from '../types/newsletterTypes';

const initialState = {
  loading: false,
  subscribed: false,
  confirmed: false,
  subscribers: [],
  subscribersCount: {
    active: 0,
    total: 0,
    unconfirmed: 0
  },
  pagination: {
    page: 1,
    limit: 50,
    total: 0,
    pages: 0
  },
  error: null,
};

const newsletterReducer = (state = initialState, action) => {
  switch (action.type) {
    // SUBSCRIBE NEWSLETTER
    case types.SUBSCRIBE_NEWSLETTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.SUBSCRIBE_NEWSLETTER_SUCCESS:
      return {
        ...state,
        loading: false,
        subscribed: true,
        confirmed: false,
        error: null,
      };
    case types.SUBSCRIBE_NEWSLETTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // CONFIRM SUBSCRIPTION
    case types.CONFIRM_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.CONFIRM_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        confirmed: true,
        error: null,
      };
    case types.CONFIRM_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // UNSUBSCRIBE NEWSLETTER
    case types.UNSUBSCRIBE_NEWSLETTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UNSUBSCRIBE_NEWSLETTER_SUCCESS:
      return {
        ...state,
        loading: false,
        subscribed: false,
        confirmed: false,
        error: null,
      };
    case types.UNSUBSCRIBE_NEWSLETTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // FETCH SUBSCRIBERS
    case types.FETCH_SUBSCRIBERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_SUBSCRIBERS_SUCCESS:
      return {
        ...state,
        loading: false,
        subscribers: Array.isArray(action.payload) ? action.payload : action.payload.data || [],
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };
    case types.FETCH_SUBSCRIBERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // FETCH SUBSCRIBERS COUNT
    case types.FETCH_SUBSCRIBERS_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_SUBSCRIBERS_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        subscribersCount: action.payload.data || action.payload,
        error: null,
      };
    case types.FETCH_SUBSCRIBERS_COUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default newsletterReducer;


